import { render } from "./AI-ChatBot.vue?vue&type=template&id=28714329&scoped=true"
import script from "./AI-ChatBot.vue?vue&type=script&lang=js"
export * from "./AI-ChatBot.vue?vue&type=script&lang=js"

import "./AI-ChatBot.vue?vue&type=style&index=0&id=28714329&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28714329"]])

export default __exports__